/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'querystring';

import ConsentBanner from '@aetn/ui-standard/ConsentBanner';
import Tealium from '@aetn/ui-standard/Tealium';

import PageFooter from '../PageFooter';
import SEO from '../Seo';

import { useStaticQuery, graphql } from 'gatsby';
import Header from './header';
import './layout.css';
import './nav.css';
import './mobile.css';

const Layout = ({ children }) => {
  const { country, state } =
    typeof window !== 'undefined' &&
    queryString.parse(window.location.search.slice(1));

  const tealiumConfig = {
    profile: 'history',
    tealiumEnv: 'prod',
  };

  return (
    <>
      <Header siteTitle={'Washington'} />
      <main>{children}</main>
      <PageFooter />
      <SEO
        title="George Washington: An Interactive Map of His Key Military Battles"
        description="Explore the epic battles that made him into a legendary general—and led to American freedom."
        image="https://cropper.watch.aetnd.com/cdn.watch.aetnd.com/sites/2/2020/02/gw.map_.promo_.jpg"
        author="@history"
        url="https://www.history.com/george-washington-battle-map-american-revolution/index.html"
      />
      <ConsentBanner {...{ country, state, runtimeEnv: 'prod' }} />
      <Tealium config={tealiumConfig} />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
